export default {
  id: 0,
  nome: '',
  cnpj: '',
  contato: '',
  responsavel: '',
  representane: ''
}
